// Textos de Fuxi, el asistente de sonido (chat del rack + orbe). Claves con prefijo "assistant.".
// {name} es el nombre del asistente (ASSISTANT_NAME en components/assistant/fuxi.js).
const en = {
  'assistant.orb': 'Talk to {name}',
  'assistant.title': '{name}, sound assistant',
  'assistant.subtitle': 'Music dragon · EQ, volume and effects for you',
  'assistant.welcome.title': 'Hi, I\'m {name}',
  'assistant.hello': 'In Chinese mythology {name} created music. Tell me how you want it to sound — "warmer", "I can\'t understand the vocals", "make it sound like a concert" — or start from a template. I always protect your ears.',
  'assistant.placeholder': 'Tell {name} how it should sound…',
  'assistant.send': 'Send',
  'assistant.thinking': '{name} is thinking…',

  'assistant.flip.toRack': 'Show the rack',
  'assistant.flip.toChat': 'Talk to {name}',
  'assistant.motion.on': 'Turn animations on',
  'assistant.motion.off': 'Turn animations off',
  'assistant.motion.hint': 'Your system asks for fewer animations (on Windows: "Show animations" is off).',
  'assistant.penta': 'The five notes of the Chinese pentatonic scale: gōng, shāng, jué, zhǐ, yǔ',

  'assistant.chats.title': 'Conversations',
  'assistant.chats.new': 'New conversation',
  'assistant.chats.empty': 'Your conversations will appear here.',
  'assistant.chats.delete': 'Delete conversation',
  'assistant.chats.confirmDelete': 'Delete this conversation? It cannot be undone.',

  'assistant.chip.improve': 'improve the audio',
  'assistant.chip.warm': 'warmer',
  'assistant.chip.space': 'more space',
  'assistant.chip.voice': 'vocals up front',

  'assistant.summary.template': 'Template: {name}',
  'assistant.summary.config': 'My setup: {name}',
  'assistant.summary.eq': 'EQ: {n} bands',
  'assistant.summary.master': 'master {d} %',
  'assistant.fx.reverb': 'reverb',
  'assistant.fx.comp': 'compressor',
  'assistant.fx.stereo': 'stereo',
  'assistant.fx.corrector': 'corrector',

  'assistant.source.groq': 'AI',
  'assistant.source.groqTitle': 'Answered by the AI (Groq)',
  'assistant.source.keywords': 'offline',
  'assistant.source.keywordsTitle': 'Answered by the offline assistant: the AI is not available right now',
  'assistant.source.plantilla': 'template',
  'assistant.source.plantillaTitle': 'Template applied directly',
  'assistant.source.limited': 'You made many requests in a row: the offline assistant answers for a few minutes',

  'assistant.undo.title': 'Undo the last change',
  'assistant.undo.done': 'Done, back to how it sounded before.',
  'assistant.undo.empty': 'There is nothing to undo yet.',

  'assistant.error.configGone': "I couldn't find that setup anymore. Check \"My setups\" in the rack bar.",
  'assistant.warn.corrector': 'To correct your headphones, add a Corrector to the rack and pick your model first.',
  'assistant.error.network': 'I could not reach the server. Check your connection and try again.',
  'assistant.error.rackFull': 'The rack is full: some changes had no free slot. Free a slot and ask me again.',
};

const es = {
  'assistant.orb': 'Hablar con {name}',
  'assistant.title': '{name}, asistente de sonido',
  'assistant.subtitle': 'Dragón de la música · EQ, volumen y efectos por ti',
  'assistant.welcome.title': 'Hola, soy {name}',
  'assistant.hello': 'En la mitología china {name} creó la música. Dime cómo quieres que suene —«más cálido», «no se entiende la voz», «que suene como un concierto»— o empieza con una plantilla. Siempre cuido tus oídos.',
  'assistant.placeholder': 'Dile a {name} cómo quieres que suene…',
  'assistant.send': 'Enviar',
  'assistant.thinking': '{name} está pensando…',

  'assistant.flip.toRack': 'Ver el rack',
  'assistant.flip.toChat': 'Hablar con {name}',
  'assistant.motion.on': 'Activar animaciones',
  'assistant.motion.off': 'Quitar animaciones',
  'assistant.motion.hint': 'Tu sistema pide menos animaciones (en Windows: «Mostrar animaciones» está apagado).',
  'assistant.penta': 'Las cinco notas de la pentatónica china: gōng, shāng, jué, zhǐ, yǔ',

  'assistant.chats.title': 'Conversaciones',
  'assistant.chats.new': 'Nueva conversación',
  'assistant.chats.empty': 'Aquí aparecerán tus conversaciones.',
  'assistant.chats.delete': 'Borrar conversación',
  'assistant.chats.confirmDelete': '¿Borrar esta conversación? No se puede deshacer.',

  'assistant.chip.improve': 'mejora el audio',
  'assistant.chip.warm': 'más cálido',
  'assistant.chip.space': 'más espacio',
  'assistant.chip.voice': 'voz al frente',

  'assistant.summary.template': 'Plantilla: {name}',
  'assistant.summary.config': 'Mi configuración: {name}',
  'assistant.summary.eq': 'EQ: {n} bandas',
  'assistant.summary.master': 'master {d} %',
  'assistant.fx.reverb': 'reverb',
  'assistant.fx.comp': 'compresor',
  'assistant.fx.stereo': 'estéreo',
  'assistant.fx.corrector': 'corrector',

  'assistant.source.groq': 'IA',
  'assistant.source.groqTitle': 'Respondió la IA (Groq)',
  'assistant.source.keywords': 'local',
  'assistant.source.keywordsTitle': 'Respondió el asistente local: la IA no está disponible ahora',
  'assistant.source.plantilla': 'plantilla',
  'assistant.source.plantillaTitle': 'Plantilla aplicada directamente',
  'assistant.source.limited': 'Hiciste muchas peticiones seguidas: durante unos minutos responde el asistente local',

  'assistant.undo.title': 'Deshacer el último cambio',
  'assistant.undo.done': 'Listo, volví a como sonaba antes.',
  'assistant.undo.empty': 'Todavía no hay nada que deshacer.',

  'assistant.error.configGone': 'Ya no encuentro esa configuración. Revisa «Mis configuraciones» en la barra del rack.',
  'assistant.warn.corrector': 'Para corregir tus audífonos, primero agrega un Corrector al rack y elige tu modelo.',
  'assistant.error.network': 'No pude hablar con el servidor. Revisa la conexión e inténtalo otra vez.',
  'assistant.error.rackFull': 'El rack está lleno: algunos cambios no tenían hueco libre. Libera un hueco y vuelve a pedírmelo.',
};

const assistant = { en, es };
export default assistant;
